import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, removeToken } from '@/utils/auth'
import { isPathMatch } from '@/utils/validate'
import { isRelogin } from '@/utils/request'
import request from '@/utils/request'
import defAva from '@/assets/images/profile.jpg'
import { initWebSocket } from '@/utils/websocket'

NProgress.configure({ showSpinner: false })

const whiteList = ['/lginindex']

const isWhiteList = (path) => {
  return whiteList.some(pattern => isPathMatch(pattern, path))
}

// 标记是否正在加载动态路由，防止重复请求
let isRoutesLoading = false

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  const hasToken = getToken()
  console.log(to.path + " beforeEach hasToken=" + hasToken)

  if (hasToken) {
    if (to.path === '/lginindex') {
      // 已登录状态访问登录页，重定向到首页
      next({ path: '/indexNew' })
      NProgress.done()
    } else {
      // 判断是否已加载动态路由（刷新后 sidebarRouters 为空需重新生成）
      const hasRoutes = store.getters.sidebarRouters && store.getters.sidebarRouters.length > 0
      if (!hasRoutes && !isRoutesLoading) {
        isRoutesLoading = true
        try {
          // 1. 请求后端获取用户信息和菜单
          const initRes = await request.get('/indexNew')
          if (initRes.code === '1') {
            // 2. 恢复用户信息到 Vuex
            store.commit('user/SET_TOKEN', hasToken)
            store.commit('user/SET_NAME', initRes.account || '')
            store.commit('user/SET_NICK_NAME', initRes.userName || '')
            store.commit('user/SET_AVATAR', defAva)
            // 恢复权限数据（页面刷新时 Vuex 已清空，需要重新解析 modules 设置 permissions）
            const permissions = (initRes.modules || '').replace(/\]\[/g, ',').replace(/[\[\]]/g, '').split(',').filter(Boolean)
            store.commit('user/SET_PERMISSIONS', permissions)
            // 存储 WebSocket 连接信息（页面刷新时从 sessionStorage 恢复后Layout会重新连接）
            if (initRes.wsUrl && initRes.userId) {
              sessionStorage.setItem('websocket_userId', JSON.stringify({ wsUrl: initRes.wsUrl, userId: initRes.userId }))
            }
            // 3. 生成动态路由
            await store.dispatch('GenerateRoutes', initRes.menuList)
            // 4. replace 方式重新进入当前页面，确保路由匹配
            next({ ...to, replace: true })
          } else {
            // 接口返回异常，清除token（Vuex + Cookie）跳转登录页
            store.commit('user/SET_TOKEN', '')
            store.commit('user/SET_ROLES', [])
            store.commit('user/SET_PERMISSIONS', [])
            removeToken()
            isRoutesLoading = false
            next(`/lginindex?redirect=${to.path}`)
            NProgress.done()
          }
        } catch (err) {
          console.error('路由守卫刷新获取菜单失败：', err)
          // 失败时清除token（Vuex + Cookie），跳转登录页
          store.commit('user/SET_TOKEN', '')
          store.commit('user/SET_ROLES', [])
          store.commit('user/SET_PERMISSIONS', [])
          removeToken()
          isRoutesLoading = false
          next(`/lginindex?redirect=${to.path}`)
          NProgress.done()
        }
      } else if (isRoutesLoading) {
        // 正在加载路由中，放行当前导航避免死循环
        next()
      } else {
        next()
      }
    }
  } else {
    // 未登录
    if (isWhiteList(to.path)) {
      next()
    } else {
      next('/lginindex')
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})
